/* Hidden Workshop Studios Password Countdown v2.0 - section controller.
   One instance per section root. WeakMap registry, AbortController cleanup,
   Shopify Theme Editor lifecycle, hidden-tab and offscreen pausing for the
   progress ring, Web Share with clipboard fallback, semantic password
   triggers for the Dawn password modal.
   Countdown: flip.min.js (Tick) initializes via the data-did-init callback
   registered here. This asset must load before flip.min.js (the section
   emits both script tags in that order, deferred). */
(function () {
  'use strict';

  if (window.__hwsPwControllerLoaded) return;
  window.__hwsPwControllerLoaded = true;

  var registry = new WeakMap();
  var instancesBySid = {};

  function HwsPw(root) {
    this.root = root;
    this.destroyed = false;
    this.counter = null;
    this.tickEl = root.querySelector('.tick');
    this.ringTimer = null;
    this.ringDone = false;
    this.visible = !document.hidden;
    this.onscreen = true;
    this.io = null;
    this.abort = typeof AbortController !== 'undefined' ? new AbortController() : null;

    var cfgEl = root.querySelector('[data-hws-pw-config]');
    this.config = null;
    if (cfgEl) {
      try { this.config = JSON.parse(cfgEl.textContent); } catch (e) { this.config = null; }
    }
    if (!this.config) return;

    this.sid = this.config.sid;
    this.cbName = 'hwsFlipInit_' + String(this.sid).replace(/-/g, '_');
    instancesBySid[this.sid] = this;

    this.registerFlipCallback();
    this.initPasswordTriggers();
    this.initShare();
    this.initNewsletter();
    this.initRing();
    this.initVisibility();
  }

  HwsPw.prototype.listen = function (target, type, fn) {
    var opts = this.abort ? { signal: this.abort.signal } : false;
    target.addEventListener(type, fn, opts);
  };

  /* --- Countdown (flip.min.js) --- */
  HwsPw.prototype.registerFlipCallback = function () {
    var self = this;
    window[self.cbName] = function (tick) { self.onTickInit(tick); };
  };

  HwsPw.prototype.onTickInit = function (tick) {
    if (this.destroyed || !this.config.showCountdown) return;
    var L = this.config.labels;
    var fmt = this.config.format;
    if (!fmt || !fmt.length) return;
    if (fmt.indexOf('d') > -1) {
      tick.setConstant('DAY_SINGULAR', L.daySg);
      tick.setConstant('DAY_PLURAL', L.dayPl);
    }
    if (fmt.indexOf('h') > -1) {
      tick.setConstant('HOUR_SINGULAR', L.hrSg);
      tick.setConstant('HOUR_PLURAL', L.hrPl);
    }
    if (fmt.indexOf('m') > -1) {
      tick.setConstant('MINUTE_SINGULAR', L.minSg);
      tick.setConstant('MINUTE_PLURAL', L.minPl);
    }
    if (fmt.indexOf('s') > -1) {
      tick.setConstant('SECOND_SINGULAR', L.secSg);
      tick.setConstant('SECOND_PLURAL', L.secPl);
    }
    var self = this;
    var counter = Tick.count.down(this.config.launchISO, { format: fmt });
    counter.onupdate = function (value) { tick.value = value; };
    counter.onended = function () {
      var cdWrap = self.root.querySelector('.hws-pw__countdown');
      if (cdWrap) cdWrap.style.display = 'none';
      var expiredEl = self.root.querySelector('[data-hws-expired]');
      if (expiredEl) expiredEl.style.display = '';
    };
    this.counter = counter;
  };

  /* Re-parse for Theme Editor reloads where flip has already booted. */
  HwsPw.prototype.parseCountdown = function () {
    var self = this;
    if (!self.config.showCountdown || !self.tickEl) return;
    if (typeof Tick === 'undefined' || !Tick.DOM) return;
    setTimeout(function () {
      if (self.destroyed) return;
      try { Tick.DOM.parse(self.root); } catch (e) { /* content stays visible */ }
    }, 50);
  };

  /* --- Password modal triggers (semantic buttons) --- */
  HwsPw.prototype.initPasswordTriggers = function () {
    var self = this;
    this.listen(this.root, 'click', function (e) {
      var btn = e.target.closest('[data-hws-pw-open]');
      if (!btn) return;
      e.preventDefault();
      var details = document.querySelector('password-modal details');
      if (!details) return;
      details.open = true;
      var input = details.querySelector('.field__input, input[type="password"]');
      if (input) {
        try { input.focus(); } catch (err) { /* focus is best-effort */ }
      }
    });
  };

  /* --- Share (Web Share API with clipboard fallback) --- */
  HwsPw.prototype.initShare = function () {
    var self = this;
    var btn = this.root.querySelector('[data-hws-share]');
    if (!btn) return;
    this.listen(btn, 'click', function () {
      var title = btn.getAttribute('data-share-title') || '';
      var text = btn.getAttribute('data-share-text') || '';
      var url = btn.getAttribute('data-share-url') || window.location.href;
      var full = title + '\n\n' + text + '\n\n' + url;
      var copied = function () {
        btn.classList.add('is-copied');
        setTimeout(function () { btn.classList.remove('is-copied'); }, 2000);
      };
      if (navigator.share) {
        navigator.share({ title: title, text: text, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(full).then(copied).catch(function () {});
      } else {
        var t = document.createElement('textarea');
        t.value = full;
        t.style.position = 'fixed';
        t.style.opacity = '0';
        document.body.appendChild(t);
        t.select();
        try { document.execCommand('copy'); } catch (err) { /* no-op */ }
        document.body.removeChild(t);
        copied();
      }
    });
  };

  /* --- Newsletter success state --- */
  HwsPw.prototype.initNewsletter = function () {
    var nlWrap = this.root.querySelector('[data-hws-newsletter]');
    if (!nlWrap) return;
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('customer_posted') === 'true' || params.has('customer_posted')) {
        nlWrap.classList.add('is-success');
      }
    } catch (e) { /* URLSearchParams unavailable: form still posts normally */ }
  };

  /* --- Progress ring: 1s cadence, stops at 100, pauses hidden/offscreen --- */
  HwsPw.prototype.initRing = function () {
    var self = this;
    if (!this.config.ring || !this.config.ring.enabled) return;
    this.ringFill = this.root.querySelector('.hws-pw__ring-fill');
    this.ringPct = this.root.querySelector('[data-hws-ring-pct]');
    if (!this.ringFill) return;
    this.ringStart = new Date(this.config.ring.start);
    this.ringLaunch = new Date(this.config.launchISO);
    var r = parseFloat(this.ringFill.getAttribute('data-radius'));
    this.ringCirc = 2 * Math.PI * r;
    if (isNaN(this.ringStart.getTime()) || isNaN(this.ringLaunch.getTime()) || !isFinite(this.ringCirc)) return;
    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver(function (entries) {
        self.onscreen = entries[0] ? entries[0].isIntersecting : true;
        self.scheduleRing();
      });
      this.io.observe(this.root);
    }
    this.updateRing();
    this.scheduleRing();
  };

  HwsPw.prototype.updateRing = function () {
    var span = this.ringLaunch - this.ringStart;
    var pct = span > 0 ? ((Date.now() - this.ringStart.getTime()) / span) * 100 : 100;
    pct = Math.min(100, Math.max(0, pct));
    this.ringFill.style.strokeDasharray = this.ringCirc;
    this.ringFill.style.strokeDashoffset = this.ringCirc - (this.ringCirc * pct / 100);
    if (this.ringPct) this.ringPct.textContent = Math.round(pct) + '%';
    if (pct >= 100) this.ringDone = true;
  };

  HwsPw.prototype.scheduleRing = function () {
    var self = this;
    if (this.ringTimer) { clearTimeout(this.ringTimer); this.ringTimer = null; }
    if (this.destroyed || this.ringDone || !this.ringFill) return;
    if (!this.visible || !this.onscreen) return;
    this.ringTimer = setTimeout(function () {
      self.ringTimer = null;
      self.updateRing();
      self.scheduleRing();
    }, 1000);
  };

  /* --- Hidden tab pausing --- */
  HwsPw.prototype.initVisibility = function () {
    var self = this;
    this.listen(document, 'visibilitychange', function () {
      self.visible = !document.hidden;
      self.scheduleRing();
    });
  };

  /* --- Teardown --- */
  HwsPw.prototype.destroy = function () {
    this.destroyed = true;
    if (this.abort) this.abort.abort();
    if (this.ringTimer) { clearTimeout(this.ringTimer); this.ringTimer = null; }
    if (this.io) { this.io.disconnect(); this.io = null; }
    if (this.counter && this.counter.timer && this.counter.timer.stop) {
      try { this.counter.timer.stop(); } catch (e) { /* already stopped */ }
    }
    this.counter = null;
    if (this.tickEl && typeof Tick !== 'undefined' && Tick.DOM && Tick.DOM.destroy) {
      try { Tick.DOM.destroy(this.tickEl); } catch (e) { /* not initialized */ }
    }
    if (window[this.cbName]) {
      try { delete window[this.cbName]; } catch (e) { window[this.cbName] = undefined; }
    }
    if (instancesBySid[this.sid] === this) delete instancesBySid[this.sid];
    registry.delete(this.root);
  };

  /* --- Boot + Theme Editor lifecycle --- */
  function initRoot(root) {
    if (!root || registry.has(root)) return;
    var inst = new HwsPw(root);
    registry.set(root, inst);
    return inst;
  }

  function findRoot(container) {
    if (!container) return null;
    if (container.matches && container.matches('[data-hws-pw]')) return container;
    return container.querySelector ? container.querySelector('[data-hws-pw]') : null;
  }

  /* Theme Editor re-renders insert fresh section HTML; inline effect-snippet
     scripts may or may not auto-execute depending on editor behavior. Cloning
     them guarantees execution; each snippet carries an idempotence guard so a
     double run is a no-op, and a cleanup registry stops prior loops. */
  function reviveFxScripts(root) {
    var scripts = root.querySelectorAll('.hws-pw__fx script');
    for (var i = 0; i < scripts.length; i++) {
      var old = scripts[i];
      if (old.type && old.type !== 'text/javascript') continue;
      var s = document.createElement('script');
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    }
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = findRoot(e.target);
    if (!root) return;
    var old = registry.get(root);
    if (old) old.destroy();
    var inst = initRoot(root);
    if (inst) inst.parseCountdown();
    reviveFxScripts(root);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = findRoot(e.target);
    if (!root) return;
    var inst = registry.get(root);
    if (inst) inst.destroy();
  });

  document.addEventListener('shopify:section:select', function (e) {
    /* No behavior required: nothing autoplays that must pause on selection.
       Guarded no-op so the editor never throws here. */
    void findRoot(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    /* All content blocks are always visible; effect blocks hidden for the
       current breakpoint stay hidden by design. Guarded no-op. */
    void e;
  });

  function boot() {
    var roots = document.querySelectorAll('[data-hws-pw]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
